import HelperEnv from '../helpers/HelperEnv';
import HelperApis from '../helpers/HelperApis';
import { rejectPostsUnauthorised } from './actionsApi';
import HelperCriteriaCalculator from '../helpers/HelperCriteriaCalculator';
import { fetchSimulationVehicleDetails } from './actionsApiSimulation';

/******************************************************
 *
 * init Calculator
 *
 ******************************************************/
export const CALCULATOR_INIT = 'CALCULATOR_INIT';
function initCalculator(vehicle) {
    return {
        type: CALCULATOR_INIT, payload: { vehicle: vehicle }
    }
}

/******************************************************
 *
 * obtain offers
 *
 ******************************************************/

export const REQUEST_POSTS_OFFERS = 'REQUEST_POSTS_OFFERS';
export const RECEIVE_POSTS_OFFERS = 'RECEIVE_POSTS_OFFERS';
export const REJECT_POSTS_OFFERS = 'REJECT_POSTS_OFFERS';

function requestPostsOffers() {
    return { type: REQUEST_POSTS_OFFERS }
}
function rejectPostsOffers() {
    return { type: REJECT_POSTS_OFFERS }
}
function receivePostsOffers(offers, parameters, hasOffers) {
    return {
        type: RECEIVE_POSTS_OFFERS,
        payload: { offers, parameters, hasOffers }
    }
}

export function fetchOffersIfNeeded(state, dispatch, vehicle, parameters) {
    let isInitial = true;
    if (state.testCriteria != null && state.testCriteria.parameters != null) {
        isInitial = false;
    }
    if (parameters == null && !isInitial) {
        parameters = state.testCriteria.parameters;
    }
    if (parameters === '') {
        parameters = null;
    }
    if (vehicle == null && state.testCriteria.vehicle != null) {
        vehicle = state.testCriteria.vehicle;
    }
    if (shouldFetchOffers(state)) {
        return fetchOffers(dispatch,
            { context: state.testCriteria.context, vehicle: vehicle, partExchange: state.testCriteria.partExchange, parameters: parameters },
            state.env, state.settings.amountNature, state.settings, isInitial, state.calculator.calculatorMode);
    }
    return null;
}

function shouldFetchOffers(state) {
    return (
        HelperEnv.isFetchPossible(state.env, state.settings)
        && !state.posts.isFetchingOffers
    );
}

function fetchOffers(dispatch, functionnalPayload, env, amountNature, settings, isInitial, calculatorMode) {
    const context = functionnalPayload.context;
    const vehicle = functionnalPayload.vehicle;
    const partExchange = functionnalPayload.partExchange;
    const parameters = functionnalPayload.parameters;
    dispatch(requestPostsOffers());
    dispatch(initCalculator(vehicle));
    var vehDescType = settings != null && settings.vehDescType != null ? settings.vehDescType : 'MANUFACTURER';
    var url = HelperEnv.getOfferBaseUrl(env, settings) + HelperEnv.getUriSimulationOffers(vehDescType);
    var contextCall = HelperApis.getContextAPICall(context, settings, false);
    var auth = HelperEnv.isAuthSimulationPublic(env, settings) ? HelperApis.getBasicAuth(env) : '';
    var request = {
        context: contextCall,
        vehicle: vehicle,
    };
    var headers = HelperApis.getHeaderBasicAuth(auth, HelperEnv.getSimuClientId(settings));
    fetch(url, {
        method: 'post',
        headers: headers,
        body: JSON.stringify(request)
    }).then(res => {
        if (res.status !== 200) {
            dispatch(rejectPostsUnauthorised({ resHttpStatus: res.status, statusText: res.statusText }));
        }
        if (!res.ok) {
            dispatch(rejectPostsOffers());
        } else {
            return res.json()
        }
        return null;
    }).catch((error) => {
        dispatch(rejectPostsUnauthorised({ error: error }));
    }).then(json => {
        fetchOfferThenContinue(dispatch, json, calculatorMode,
            { context: context, vehicle: vehicle, partExchange: partExchange, parameters: parameters },
            { env: env, amountNature: amountNature, settings: settings }, isInitial)
    });
}

function fetchOfferThenContinue(dispatch, json, calculatorMode, functionnalPayload, envSettingsPayload, isInitial) {
    var offers = Object.values(json.financialOffers);
    var hasOffers = !json.hasError;
    var updatedParameters = null;
    if (functionnalPayload.parameters == null || Object.keys(functionnalPayload.parameters).length === 0) {
        for (var offerKey in offers) {
            if (offers[offerKey].default) {
                updatedParameters = offers[offerKey].financialProductId;
                break;
            }
        }
    } else {
        updatedParameters = functionnalPayload.parameters;
    }
    dispatch(receivePostsOffers(offers, updatedParameters, hasOffers))
    if (calculatorMode === 'SVCLEVEL') {
        fetchCallServiceLevels(dispatch, { ...functionnalPayload, parameters: updatedParameters },
            envSettingsPayload.env, envSettingsPayload.amountNature, envSettingsPayload.settings, isInitial);
    } else {
        fetchCallCriteria(dispatch, { ...functionnalPayload, parameters: updatedParameters },
            envSettingsPayload.env, envSettingsPayload.amountNature, envSettingsPayload.settings, isInitial, false);
    }
}

/******************************************************
 *
 * obtain service levels
 *
 ******************************************************/

export const REQUEST_POSTS_SVCLEVELS = 'REQUEST_POSTS_SVCLEVELS';
export const RECEIVE_POSTS_SVCLEVELS = 'RECEIVE_POSTS_SVCLEVELS';
export const REJECT_POSTS_SVCLEVELS = 'REJECT_POSTS_SVCLEVELS';

export function fetchServiceLevelsIfNeeded(state, dispatch, productKey) {
    if (shouldFetchServiceLevels(state)) {
        const parameters = state.calculator.parameters && state.calculator.parameters.productKey === productKey ? state.calculator.parameters : { productKey: productKey };
        return fetchCallServiceLevels(dispatch,
            {
                context: state.testCriteria.context,
                vehicle: state.calculator.vehicle, partExchange: state.testCriteria.partExchange, parameters: parameters
            },
            state.env, state.settings.amountNature, state.settings, false)
    }
    return null;
}

function requestPostsServiceLevels() {
    return { type: REQUEST_POSTS_SVCLEVELS }
}
function rejectPostsServiceLevels() {
    return { type: REJECT_POSTS_SVCLEVELS }
}
function receivePostsServiceLevels(responseServiceLevels) {
    return {
        type: RECEIVE_POSTS_SVCLEVELS,
        payload: { responseServiceLevels }
    }
}

function shouldFetchServiceLevels(state) {
    return (
        HelperEnv.isFetchPossible(state.env, state.settings)
        && !state.posts.isFetchingCriteria
        && state.calculator != null && state.calculator.responseOffers != null && state.calculator.calculatorMode === 'SVCLEVEL'
    );
}

function fetchCallServiceLevels(dispatch, functionnalPayload, env, amountNature, settings, isInitial) {
    const context = functionnalPayload.context;
    const vehicle = functionnalPayload.vehicle;
    const partExchange = functionnalPayload.partExchange;
    const parameters = functionnalPayload.parameters;
    dispatch(requestPostsServiceLevels());
    if (parameters == null || Object.keys(parameters).length === 0) {
        return;
    }
    var contextCall = HelperApis.getContextAPICall(context, settings, false);
    var vehDescType = settings != null && settings.vehDescType != null ? settings.vehDescType : 'MANUFACTURER';
    var url = HelperEnv.getOfferBaseUrl(env, settings) + HelperEnv.getUriServiceLevels(vehDescType);
    var auth = HelperEnv.isAuthSimulationPublic(env, settings) ? HelperApis.getBasicAuth(env) : '';
    var productKey = parameters.productKey;
    var request = {
        context: contextCall,
        vehicle: vehicle,
        financialProductId: {
            productKey: productKey
        }
    };
    var headers = HelperApis.getHeaderBasicAuth(auth, HelperEnv.getSimuClientId(settings));
    fetch(url, {
        method: 'post',
        headers: headers,
        body: JSON.stringify(request)
    }).then(res => {
        if (res.status !== 200) {
            dispatch(rejectPostsUnauthorised({ resHttpStatus: res.status, statusText: res.statusText }));
        }
        if (!res.ok) {
            dispatch(rejectPostsServiceLevels());
        } else {
            return res.json()
        }
        return null;
    }).catch((error) => {
        dispatch(rejectPostsUnauthorised({ error: error }));
    }).then(json => {
        if (json != null) {
            dispatch(receivePostsServiceLevels({ ...json }));
            fetchCallCriteria(dispatch,
                { context: context, vehicle: vehicle, partExchange: partExchange, parameters: parameters },
                env, amountNature, settings, isInitial, false);
        }
    });
}

/******************************************************
 *
 * obtain criteria
 *
 ******************************************************/

export const REQUEST_POSTS_CRITERIA = 'REQUEST_POSTS_CRITERIA';
export const RECEIVE_POSTS_CRITERIA = 'RECEIVE_POSTS_CRITERIA';
export const REJECT_POSTS_CRITERIA = 'REJECT_POSTS_CRITERIA';

export function fetchCriteriaIfNeeded(state, dispatch, productKey) {
    if (shouldFetchCriteria(state)) {
        const parameters = state.calculator.parameters && state.calculator.parameters.productKey === productKey ? state.calculator.parameters : { productKey: productKey };
        return fetchCallCriteria(dispatch,
            { context: state.testCriteria.context, vehicle: state.calculator.vehicle, partExchange: state.testCriteria.partExchange, parameters: parameters },
            state.env, state.settings.amountNature, state.settings, false, false)
    }
    return null;
}

export function fetchCriteriaOnParameterChangeIfNeeded(state, dispatch, key, value) {
    const parameters = updateParametersFromSelection(state, key, value);
    if (shouldFetchCriteria(state)) {
        return fetchCallCriteria(dispatch,
            { context: state.testCriteria.context, vehicle: state.calculator.vehicle, partExchange: state.testCriteria.partExchange, parameters: parameters },
            state.env, state.settings.amountNature, state.settings, false, true)
    }
    return null;
}

function requestPostsCriteria() {
    return { type: REQUEST_POSTS_CRITERIA }
}
function rejectPostsCriteria() {
    return { type: REJECT_POSTS_CRITERIA }
}
function receivePostsCriteria(responseCriteria, parameters, amountNature) {
    return {
        type: RECEIVE_POSTS_CRITERIA,
        payload: { responseCriteria, parameters, amountNature }
    }
}

function shouldFetchCriteria(state) {
    return (
        HelperEnv.isFetchPossible(state.env, state.settings)
        && !state.posts.isFetchingCriteria
        && state.calculator != null && state.calculator.responseOffers != null
    );
}

function fetchCallCriteria(dispatch, functionnalPayload, env, amountNature, settings, isInitial, isCriteriaSelected) {
    const context = functionnalPayload.context;
    const vehicle = functionnalPayload.vehicle;
    const parameters = functionnalPayload.parameters;

    dispatch(requestPostsCriteria());
    if (parameters == null || Object.keys(parameters).length === 0) {
        return;
    }
    var contextCall = HelperApis.getContextAPICall(context, settings, false);
    var vehDescType = HelperApis.getVehDescType(settings);
    var url = HelperEnv.getOfferBaseUrl(env, settings) + HelperEnv.getUriSimulationCriteria(vehDescType);
    var auth = HelperApis.getBasicAuthIfPublicApi(env, settings);
    var parametersPayload = isCriteriaSelected ? { ...parameters } : { productKey: parameters.productKey };
    var request = {
        context: contextCall,
        vehicle: vehicle,
        parameters: parametersPayload
    };
    var headers = HelperApis.getHeaderBasicAuth(auth, HelperEnv.getSimuClientId(settings));
    fetch(url, {
        method: 'post',
        headers: headers,
        body: JSON.stringify(request)
    }).then(res => {
        if (res.status !== 200) {
            dispatch(rejectPostsUnauthorised({ resHttpStatus: res.status, statusText: res.statusText }));
        }
        if (!res.ok) {
            dispatch(rejectPostsCriteria());
        } else {
            return res.json()
        }
        return null;
    }).catch((error) => {
        dispatch(rejectPostsUnauthorised({ error: error }));
    }).then(json => {
        dispatchFromCallCriteria(json, dispatch, functionnalPayload, { env: env, settings: settings }, amountNature, isInitial, isCriteriaSelected);
    });
}

function dispatchFromCallCriteria(json, dispatch, functionnalPayload, envSettingsPayload, amountNature, isInitial, isCriteriaSelected) {
    const context = functionnalPayload.context;
    const vehicle = functionnalPayload.vehicle;
    const partExchange = functionnalPayload.partExchange;
    const parameters = functionnalPayload.parameters;
    const env = envSettingsPayload.env;
    const settings = envSettingsPayload.settings;

    if (json != null) {
        var duration = buildNewDurationFromCriteria(json, parameters);
        var mileage = buildNewMileageFromCriteria(json, parameters);
        var depositElt = buildNewDepositFromCriteria(json, parameters, vehicle, amountNature);
        var parametersForDataMap = parameters != null ? parameters : { duration: duration, annualMileage: mileage };
        var dataSvcMap = HelperCriteriaCalculator.getServiceMap(json.packages, json.services, parametersForDataMap);
        var newParameters = {
            "duration": duration,
            "deposit": depositElt.deposit,
            "depositAmountKind": depositElt.depositAmtKind,
            "depositAmountNature": depositElt.depositAmtNat,
            "annualMileage": mileage,
            "productKey": parameters ? parameters.productKey : null,
            "services": [
            ]
        };
        newParameters.services = HelperCriteriaCalculator.getServiceParameters(dataSvcMap);
        dispatch(receivePostsCriteria({ ...json, deposits: depositElt.deposits }, newParameters, amountNature));
        if (!isCriteriaSelected) {
            fetchSimulationVehicleDetails(dispatch,
                { context: context, vehicle: vehicle, parameters: isInitial ? null : newParameters, partExchange: partExchange },
                env, settings, true)
        }
    }
}

function buildNewDurationFromCriteria(json, parameters) {
    var durationDefault = json.durations != null ? json.durations.defaultValue : null;
    return (parameters != null && parameters.duration != null) ? parameters.duration : durationDefault;
}
function buildNewMileageFromCriteria(json, parameters) {
    var defaultMileage = json != null && json.mileages != null ? json.mileages.defaultValue : null;
    return (parameters != null && parameters.annualMileage != null) ? parameters.annualMileage : defaultMileage;
}

function buildNewDepositFromCriteria(json, parameters, vehicle, amountNature) {
    var deposits = HelperCriteriaCalculator.getDepositParametersWithDefaultAmount(json.deposits, vehicle, amountNature);
    var defaultDeposit = null;
    var depositAmtKindDefault = null;
    var depositAmtNatDefault = null;
    if (deposits != null) {
        defaultDeposit = deposits.defaultValue;
        depositAmtKindDefault = deposits.amountKind;
        depositAmtNatDefault = deposits.amountNature;
    }
    var deposit = (parameters != null && parameters.deposit != null) ? parameters.deposit : defaultDeposit;
    var depositAmtKind = (parameters != null && parameters.depositAmountKind != null) ? parameters.depositAmountKind : depositAmtKindDefault;
    var depositAmtNat = (parameters != null && parameters.depositAmountNature != null) ? parameters.depositAmountNature : depositAmtNatDefault;
    return { deposit: deposit, depositAmtKind: depositAmtKind, depositAmtNat: depositAmtNat, deposits: deposits };
}

/******************************************************
 *
 * obtain simulation after criteria selection
 *
 ******************************************************/

function shouldFetchSimulationCalculator(state) {
    return (HelperEnv.isFetchPossible(state.env, state.settings)
        && !state.posts.isFetchingSimulation
        && Object.keys(state.env).length > 0
    );
}

export function fetchSimulationVehicleDetailsIfNeededCalculator(state, dispatch, key, value, settings) {
    var context = state.testCriteria.context;
    var partExchange = state.testCriteria.partExchange;
    var vehicle = state.responseSimulation.selectedVehicle;
    var parameters = updateParametersFromSelection(state, key, value);
    if (key === 'customer') {
        context.customer = value;
    }
    if (shouldFetchSimulationCalculator(state)) {
        return fetchSimulationVehicleDetails(dispatch,
            { context: context, vehicle: vehicle, parameters: parameters, partExchange: partExchange },
            state.env, settings, true);
    }
    return null;
}

function updateParametersFromSelection(state, key, value) {
    var parameters = state.calculator.parameters;
    if (key !== 'customer') {
        parameters[key] = value;
    }
    if (key === 'duration' || key === 'annualMileage') {
        var dataSvcMap = state.calculator.svcMap;
        for (var svcKey in dataSvcMap) {
            dataSvcMap[svcKey]['selectable'] = HelperCriteriaCalculator.isSelectableCriteria(
                dataSvcMap[svcKey], parameters.duration, parameters.annualMileage, parameters.globalMileage);
        }
        parameters.services = HelperCriteriaCalculator.getServiceParameters(dataSvcMap);
    }
    return parameters;
}
